import React, { Component} from 'react';
import { connect } from "react-redux";
import ReactTable from "react-table";
import { Row, Col, Button, Modal, ModalHeader, ModalBody, ModalFooter, UncontrolledTooltip, Card, CardBody, CardHeader } from "reactstrap";
import { NotificationManager } from "react-notifications";
import LoadingSpinner from "../../components/LoadingSpinner/index";
import "react-table/react-table.css";
import Proptypes from "prop-types";
import { Link } from "react-router-dom";
import {getUrlFilterPolicies, deleteUrlFilterPolicy} from "../../actions/actionFilters"
import moment from "moment";
import { fuzzySearch } from "../../utils/helpers";

class UrlFilter extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modal: false,
            filterId: null
        };
        this.cancelDelete = this.cancelDelete.bind(this);
        this.deleteConfirm = this.deleteConfirm.bind(this);
        this.deleteFilterAction = this.deleteFilterAction.bind(this);
        this.handleDeleteSuccess = this.handleDeleteSuccess.bind(this);
        this.handleDeleteError = this.handleDeleteError.bind(this);
    }

    componentDidMount() {
        this.props.getUrlFilterPolicies();
    }

    deleteConfirm(filterId){
        this.setState({modal: !this.state.modal,
            filterId: filterId});
    }

    cancelDelete(){
        this.setState({modal: !this.state.modal});
    }

    deleteFilterAction(){
        this.props.deleteUrlFilterPolicy(this.state.filterId).
        then(() => this.handleDeleteSuccess()).
        catch(() => this.handleDeleteError());
    }

    handleDeleteSuccess(){
        const {deleteFilterErrorMessage} = this.props;
        if(deleteFilterErrorMessage) {
            NotificationManager.error(deleteFilterErrorMessage,"Delete Web Filter Policy Failed", 3000);
        }else{
            NotificationManager.success("Successfully Deleted Web Filter Policy","Delete Web Filter Policy", 3000);
            this.setState({modal: false});
            this.props.getUrlFilterPolicies();
        }
    }

    handleDeleteError(){
        const {deleteFilterError} = this.props;
        if(deleteFilterError){
            NotificationManager.error(deleteFilterError,"Failed to Delete Web Filter Policy", 3000);
            this.props.history.push("/webfilter");
        }else{
            NotificationManager.error("Failed to Delete Web Filter Policy","Delete Web Filter Policy", 3000);
            this.props.history.push("/webfilter");
        }
    }

    render() {
        if (this.props.getFilterLoading) {
            return (<div> <LoadingSpinner /></div>);
        }
        const {filters} = this.props;
        const columns = [
            {   Header: "Name",
                accessor: "filter_policy_name",
                filterMethod: fuzzySearch
            },
            {
                Header: "Description",
                accessor: "filter_policy_descriptions",
                filterMethod: fuzzySearch
            },
            {
                Header: "Actions",
                filterable: false,
                sortable: false,
                Cell: (data) => (<div className="action-btn">
                        <Link className="btn btn-success" id={"TooltipComponent"} to={{ pathname: `/viewfilter/${data.original.filter_policy_id}` }}>
                            <i className="fa fa-eye"></i></Link>
                        <Link className="btn btn-warning" id={"Tooltipss"} to={{ pathname: `/updatefilter/${data.original.filter_policy_id}` }}>
                            <i className="fa fa-pencil"></i> </Link>
                        <button className="btn btn-danger"  id={"Tooltips"} href="#"  onClick={() => this.deleteConfirm(data.original.filter_policy_id)}>
                            <i className="fa fa-trash-o"></i> </button>
                        <UncontrolledTooltip placement="right" target={"TooltipComponent"}> View </UncontrolledTooltip>
                        <UncontrolledTooltip placement="right" target={"Tooltipss"}> Edit </UncontrolledTooltip>
                        <UncontrolledTooltip placement="right" target={"Tooltips"}> Delete </UncontrolledTooltip>
                    </div>
                ),
            }];
        return(
            <div className="mt-4">
                <Row>
                    <Col sm={{ size: 10, order: 3, offset: 1 }}>
                        <Card >
                            <CardHeader>
                                <i className="fa fa-align-justify"></i> <strong>Web Filter Policies</strong>
                                <Link className="pull-right" to={{ pathname: "/createfilter" }}>
                                    <Button className="pull-right" size="sm" color="dark">
                                        Create New Policy
                                    </Button>
                                </Link>
                            </CardHeader>
                            <CardBody>
                                <ReactTable
                                    columns={columns}
                                    data={filters}
                                    defaultSorted={[{id: "filter_policy_name"}]}
                                    filterable
                                    defaultPageSize={10}
                                    className="-striped -highlight site_table"
                                />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>

                <Modal isOpen={this.state.modal} toggle={this.cancelDelete} className={this.props.className}>
                    <ModalHeader toggle={this.cancelDelete}>Delete Filter Policy <i className="fa fa-bomb" aria-hidden="true"></i>
                    </ModalHeader>
                    <ModalBody>
                        Confirm Delete Filter Policy?
                    </ModalBody>
                    <ModalFooter>
                        <Button onClick={this.deleteFilterAction} size="sm" color="danger"> <i className="fa fa-trash"></i> Delete</Button>
                        <Button onClick={this.cancelDelete} size="sm" color=" basic"><i className="fa fa-ban"></i> Close</Button>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }

}

export default connect(state => ({
        filters: state.filter.filters || [],
        categories: state.filter.categories || [],
        getFilterLoading: state.filter.getFilterLoading || false,
        getFilterErrorMessage: state.filter.getFilterErrorMessage || false,
        getFilterError: state.filter.getFilterError || null,
        deleteFilterErrorMessage: state.filter.deleteFilterErrorMessage || null,
        deleteFilterError: state.filter.deleteFilterError || null,
        deletedFilter: state.filter.deletedFilter || null,
        deleteFilterLoading: state.filter.deleteFilterLoading || null,
    }),
    dispatch => ({
        getUrlFilterPolicies: () => dispatch(getUrlFilterPolicies()),
        deleteUrlFilterPolicy: (data) => dispatch(deleteUrlFilterPolicy(data))
    }))(UrlFilter);



// WEBPACK FOOTER //
// ./src/views/UrlFilter/UrlFilter.js